import React from 'react'
import PropTypes from 'prop-types'

function FlyBaseSymbol({ symbol }) {
  return <span dangerouslySetInnerHTML={{ __html: symbol }} />
}

FlyBaseSymbol.propTypes = {
  symbol: PropTypes.any.isRequired,
}

export default FlyBaseSymbol
